import { t } from "@lingui/macro";

export const ContactEntityType = {
    MALAYSIAN_COMPANY: {
        key: 'MALAYSIAN_COMPANY',
        label: t`Company`,
    },
    MALAYSIAN_INDIVIDUAL: {
        key: 'MALAYSIAN_INDIVIDUAL',
        label: t`Individual`,
    },
    GENERAL_PUBLIC: {
        key: 'GENERAL_PUBLIC',
        label: t`General Public`,
    },
    FOREIGN_COMPANY: {
        key: 'FOREIGN_COMPANY',
        label: t`Foreign Company`,
    },
    FOREIGN_INDIVIDUAL: {
        key: 'FOREIGN_INDIVIDUAL',
        label: t`Foreign Individual`,
    },
    EXEMPTED_PERSON: {
        key: 'EXEMPTED_PERSON',
        label: t`Exempted Person`,
    },
};
